export default {
  translations: {
    login: {
      login: "Identifikohu",
      noAccount: "Nuk keni llogari?",
      haveAccount: "Keni llogari?",
      register: "Regjistrohu",
      email: "Email",
      password: "Fjalëkalimi",
      tfaCode: "Kodi i verifikimit",
      confirmPassword: "Konfirmo fjalëkalimin",
      forgotPassword: "Keni harruar fjalëkalimin?",
      resetPassword: "Rivendos fjalëkalimin",
      resetCode: "Kodi i verifikimit",
      passwordDoesNotMatch: "Fjalëkalimi nuk është i njëjtë",
      name: "Emri",
      lastname: "Mbiemri",
      sex: "Gjinia",
      birthday: "Datëlindja",
      mobileNumber: "Numri i celularit",
      country: "Shteti",
      city: "Qyteti",
      healthCenter: "Qëndra shëndetsore",
      licenceNumber: "Numri i licensës",
      cv: "Curriculum Vitae",
      language: "Gjuha",
      accountStatus: "Statusi i llogarisë",
      firstRegistration: "Rregjistrimi i parë",
      speciality: "Specialiteti",
      bio: "Biografia",
      subscriptionStatus: "Statusi i paketës",
      tier: "Paketa",
      startDate: "Data e fillimit",
      remainingDays: "Ditë të mbetura",
      blockLog: "Rregjistri i bllokimeve",
    },
    registerDoctor: {
      ok: "Në rregull",
      okRegister: "Aplikimi u krye me sukses",
      okContact: "Ju do te kontaktoheni se shpejti.",
      apply: "Apliko për tu bërë pjesë e platformës TeleShëndet.",
      note: 'Duke klikuar "Regjistrohu", ju pranoni Kushtet e Përdorimit dhe Politikën e Privatësisë së TeleShendet. Ju pranoni të merrni telefonata dhe mesazhe SMS nga TeleShendet në mënyrë që të lidheni me pacientët. Frekuenca e mesazhit varet nga aktiviteti juaj. Mund të zbatohen tarifat e mesazheve dhe të dhënave. Ju mund të hiqni dorë duke na kontaktuar në info@teleshendet.al',
      agreeTo: "Bie dakord me ",
      termsOfUse: "Kushtet e Përdorimit",
      privacyPolicy: "Politikat e Privatësisë",
    },
    forms: {
      sendResetCode: "Dërgo kodin",
      clear: "Pastro",
      requiredField: "Fushë e detyruar",
      slideOrClick: "Shtype ose rreshkit një dokument.",
      uploading: "Duke ngarkuar...",
      delete: "Fshije",
      size: "Madhësia",
      submitting: "Duke dërguar...",
      save: "Ruaj",
      changesSaved: "Ndryshimet u ruajtën",
      success: "Sukses",
      edit: "Redakto",
      view: "Shiko",
    },
    selected: "e zgjedhur",
    language: "Gjuha",
    roles: {
      admin: "Administrator",
      author: "Autor",
      doctor: "Mjek i përgjithshëm",
      specialist: "Mjek specialist",
    },
    account: {
      myAccount: "Llogaria ime",
      profile: "Profili",
      medicalCard: "Vizita",
      logout: "Dil",
      updateProfile: "Ndrysho të dhënat",
      profileTab: {
        title: "Profili",
      },
      passwordTab: {
        title: "Fjalëkalimi",
        oldPassword: "Fjalëkalimi i vjetër",
        newPassword: "Fjalëkalimi i ri",
        confirmPassword: "Konfirmo fjalëkalimin",
      },
      profilePictureTab: {
        title: "Fotografia",
        profileImage: "Fotografia e profilit",
      },
      languageTab: {
        title: "Gjuha",
      },
    },
    calls: {
      shortTitle: "Telefonata",
      title: "Lista e telefonatave",
      caller: "Telefonuesi",
      guests: "Të ftuar",
      status: "Statusi",
      date: "Data",
      duration: "Kohëzgjatja",
      none: "Asnjë",
      minutes: "minuta",
      loadMore: "Ngarko më tepër...",
      filterByDate: "Sipas datës",
      waitingCalls: "Telefonata në pritje",
      noWaitingCalls: "Nuk ka asnjë telefonatë në pritje.",
      calling: "Telefonatë nga {{name}}",
      answer: "Përgjigju",
      close: "Mbylle",
      terminateCall: "Mbyll telefonatën",
      onMic: "Hap mikrofonin",
      offMic: "Mbyll mikrofonin",
      onCam: "Hap kamerën",
      offCam: "Mbyll kamerën",
      invitieGuest: "Shto atëtar",
      listOfDoctors: "Lista e mjekëve",
      noDocotrs: "Nuk u gjend asnjë mjek.",
      invite: "Ftoje",
      statusList: {
        lost: "e humbur",
        ringing: "po bie zilja",
        started: "po kryhet",
        terminated: "e mbyllur",
        completed: "e përfunduar",
        waiting: "në pritje",
      },
    },
    patients: {
      shortTitle: "Pacientë",
      title: "Lista e pacientëve",
      name: "Emri",
      email: "E-mail",
      phone: "Telefoni",
      tier: "Paketa",
      startDate: "Data fillimit",
      expirationDate: "Data skadimit",
      registrationDate: "Data e rregjistrimit",
      none: "Asnjë",
      patient: "Pacienti",
      medicalCards: {
        title: "Lista e vizitave",
        doctor: "Mjeku",
        documents: "Dokumenta",
        comments: "Komente",
        date: "Data",
        add: "Shto vizitë",
        symtopms: "Simptoma/Ankesa",
        diagnosis: "Diagnoza",
        recommendations: "Rekomandime",
        recipe: "Receta",
        privateNote: "Komente të tjera mjekësore",
        success: "Sukses",
        createdSuccessfuly: "Vizita u shtua",

        detailsTab: {
          title: "Detaje & Komente",
          details: "Të dhënat e vizitës",
          comments: "Komente",
          download: "Shkarko",
          recipe: "Receta",
          comment: "Komenti",
          commentAdded: "Komenti u shtua",
          commentEdited: "Komenti u redaktua",
          commentDeleted: "Komenti u fshi",
          accounts: "Llogaritë",
          visitOnDate: "Vizita e datës {{date}}",
        },

        documentsTab: {
          title: "Dokumenta",
          details: "Të dhënat e dokumentit",
          list: "Lista e dokumentave",
          author: "Autori",
          description: "Përshkrimi",
          upload: "Ngarko",
          documentAdded: "Dokumenti u ruajt",
          documentDeleted: "Dokumenti u fshi",
          add: "Shto një dokument",
          document: "Dokumenti",
          documentByName: "Dokumenti {{name}}",
          formatNotSupported:
            "Skedari i formatit <small>{{format}}</small> nuk mund të shfaqet por ju mund ta shkarkoni dhe ta hapni nga kompjuteri.",
        },
      },
      temporaryBlock: {
        title: "Bllokim i përkohshëm",
        duration: "Kohëzgjatja",
        reason: "Arsyeja",
      },
    },
    events: {
      shortTitle: "Evente",
      title: "Lista e eventeve",
      organiser: "Mjeku Organizator",
      eventTitle: "Titulli",
      participants: "Pjesëmarrës",
      date: "Data",
      duration: "Kohëzgjatja",
      minutes: "minuta",
      noParticipants: "Nuk ka asnjë pjesëmarrës",
    },
  },
};
